import { Box } from "@mui/material";
import type { ReactNode } from "react";

export type EvidenceLabelKind = "verified" | "source" | "window";

/** Factual provenance metadata, not a reward badge. */
export const EvidenceLabel = ({ kind, children }: { kind: EvidenceLabelKind; children: ReactNode }) => (
  <Box
    component="span"
    data-evidence-kind={kind}
    sx={{
      display: "inline-flex",
      alignItems: "center",
      minHeight: 28,
      maxWidth: "calc(100% - 4px)",
      ml: "1px",
      mr: "3px",
      mt: "1px",
      mb: "3px",
      px: 1,
      py: 0.4,
      border: "1px solid #0a0a0a",
      borderRadius: 0,
      color: "#0a0a0a",
      bgcolor: "#f0ece2",
      fontSize: ".62rem",
      fontWeight: 800,
      letterSpacing: ".065em",
      lineHeight: 1.35,
      textTransform: "uppercase",
      whiteSpace: "normal",
      overflowWrap: "anywhere",
      transition: "transform 140ms ease, box-shadow 140ms ease",
      "&:hover": { transform: "translate(-1px,-1px)", boxShadow: "3px 3px 0 #ff3d12" },
      "@media (prefers-reduced-motion: reduce)": { transition: "none", "&:hover": { transform: "none" } },
    }}
  >
    {children}
  </Box>
);
